<template>
  <b-col cols="12" class="mb-3">
    <b-button variant="primary" class="mr-2" @click="emitCreateFolder" v-if="!isModal">New Folder</b-button>
    <b-button variant="success" class="mx-2" @click="emitCreateFile">Upload images</b-button>
    <b-button variant="success" class="mx-2" @click="emitCreateVideo">Upload videos</b-button>
    <b-button variant="success" class="mx-2" @click="emitCreateURL">Set URL</b-button>
  </b-col>
</template>

<script>
export default {
  props: {
    isModal: {
      type: [Boolean],
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    emitCreateFolder() {
      this.$emit('create-folder-clicked', {});
    },
    emitCreateFile() {
      this.$emit('create-file-clicked', {});
    },
    emitCreateVideo() {
      this.$emit('create-video-clicked', {});
    },
    emitCreateURL() {
      this.$emit('create-url-clicked', {});
    },
  },
};
</script>
